import { fullDateFullYearFormat } from "@common/helpers/date";
import { DatePicker } from "@design-system/DatePicker/DatePicker";
import type { WorkDateField } from "@api/workItem.api";
import type { ClientsWorkOverviewWorkRow } from "../clientsWorkOverviewViewConfig";
import { useConfirmWorkStartChange } from "./useConfirmWorkStartChange";
import { getWorkDateBounds, toWorkDateEdit } from "./workDateEdit";
import { useEditWorkItem } from "./workItemEditing";
import type { DisableableTrigger } from "@design-system/overlay/triggerButtonProps";

interface WorkDateControlProps {
    row: Pick<
        ClientsWorkOverviewWorkRow,
        "workStartDate" | "workDeliveryDate" | "closeId" | "workspaceId"
    >;
    field: WorkDateField;
    trigger: DisableableTrigger;
}

/**
 * A calendar opened from `trigger` that updates one work date; dates can't
 * be cleared. A new Work start saves only once the user confirms it.
 */
export const WorkDateControl = ({
    row,
    field,
    trigger,
}: Readonly<WorkDateControlProps>) => {
    const editWorkItem = useEditWorkItem();
    const { saveEdit, confirmationModal } = useConfirmWorkStartChange();
    const value = row[field] ?? undefined;
    return (
        <>
            <DatePicker
                mode="day"
                variant="panel-input"
                showTriggerIcon={false}
                required
                displayFormat={fullDateFullYearFormat}
                value={value}
                {...getWorkDateBounds(row, field)}
                onValueChange={(date) => {
                    const edit = date && toWorkDateEdit({ row, field, date });
                    if (edit) {
                        saveEdit({ edit, save: () => editWorkItem(row, edit) });
                    }
                }}
                trigger={trigger}
            />
            {confirmationModal}
        </>
    );
};
